/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const Hand3Icon = ({ width = 24, height = 24, hidden = false, title = 'Hand3' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M28.241 19.577c-.532-.3-1.1-2.747-3.258-2.747a1.262 1.262 0 0 1-.582-.07c-.134-.086-.482-2.5-2.843-2.5-.326 0-1.506.256-1.506-1.261V3.714a2.381 2.381 0 1 0-4.762 0V13s.056 1.005-.329 1.151a.628.628 0 0 1-.806-.319c-.82-2.389-2.62-7.794-2.62-7.794a2.471 2.471 0 0 0-2.673-1.707A2.383 2.383 0 0 0 6.986 7.45l3.244 9.434a8.021 8.021 0 0 1 .3 1.281 1.983 1.983 0 0 1-.893 2.183c-.18.1-.9-.231-1.712-.675-1.484-1.083-3.005-2.291-3.005-2.291-2.381-1.621-3.849-1.06-4.464-.331-.655.776-.2 2.05.747 3.032L7.3 27.01c.357.431.893 1.063 1.551 1.776a21.816 21.816 0 0 0 2.074 3.1c1.667 1.825 4.028 2.778 7.539 2.778h.054a11.225 11.225 0 0 0 6.928-2.039 7.122 7.122 0 0 0 2.545-2.959c.818-2.371 1.5-4.968 1.756-6.113a3.58 3.58 0 0 0-1.506-3.976Z"
    />
  </svg>`;
};
